import React, { createContext, useContext, useState, useEffect } from 'react';

// Create the Job Context
const JobContext = createContext(null);

// Create a provider component
export const JobProvider = ({ children }) => {
  // Initialize jobContent from localStorage, or null if not found
  const [jobContent, setJobContent] = useState(() => {
    try {
      const storedJobContent = localStorage.getItem('jobContent');
      return storedJobContent ? JSON.parse(storedJobContent) : null;
    } catch (error) {
      console.error("Error parsing jobContent from localStorage", error);
      return null;
    }
  });

  // Update localStorage whenever jobContent changes
  useEffect(() => {
    try {
      if (jobContent) {
        localStorage.setItem('jobContent', JSON.stringify(jobContent));
      } else {
        localStorage.removeItem('jobContent');
      }
    } catch (error) {
      console.error("Error saving jobContent to localStorage", error);
    }
  }, [jobContent]);

  const updateJobContent = (content) => {
    setJobContent(content);
  };

  return (
    <JobContext.Provider value={{ jobContent, updateJobContent }}>
      {children}
    </JobContext.Provider>
  );
};

// Create a custom hook to use the Job Context
export const useJob = () => {
  const context = useContext(JobContext);
  if (!context) {
    throw new Error('useJob must be used within a JobProvider');
  }
  return context;
};